module.exports = __webpack_public_path__ + "media/images/application/icons/lock-e025f38c1c8539d8af47c9e5d163ba19.svg";